import { render, staticRenderFns } from "./Hogar90.vue?vue&type=template&id=1dd139e1&scoped=true&"
import script from "./Hogar90.vue?vue&type=script&lang=js&"
export * from "./Hogar90.vue?vue&type=script&lang=js&"
import style0 from "./Hogar90.vue?vue&type=style&index=0&id=1dd139e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd139e1",
  null
  
)

export default component.exports